import { useAPIRoute } from '../../hooks/useAPIRoute';
import { useQuery } from 'react-query';
import {
    ExtraSalestoolConfigResponse,
    PluginConfigResponse,
} from 'rwl-shared/dist/models';
import { PortfolioWidgetFeatureSettings } from 'rwl-shared/dist/models/plugin/Plugin';

type UseFetchConfigParams = {
    accountId: string;
    enabled?: boolean;
};

export const useFetchConfig = ({
    accountId,
    enabled = true,
}: UseFetchConfigParams) => {
    const url = useAPIRoute('config');

    return useQuery<Config>(
        ['config', accountId],
        async () => {
            const result = await fetch(
                `${url}?` + new URLSearchParams({ accountId: accountId }),
                {
                    method: 'GET',
                }
            );
            return stripPluginConfigResponse(await result.json());
        },
        {
            // CoPilot suggested these, lets see if we like them
            enabled,
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
        }
    );
};

function stripPluginConfigResponse(
    pluginConfigResponse: PluginConfigResponseWithExtra
): Config {
    return {
        account: {
            name: pluginConfigResponse.account.name,
            geolocation: pluginConfigResponse.account.geolocation,
            mapSettings: pluginConfigResponse.account.mapSettings,
            labelsWithUsage: pluginConfigResponse.account.labelsWithUsage,
        },
        extraData: pluginConfigResponse.extraData,
        businessContactInfo: pluginConfigResponse.businessContactInfo,
    };
}

export type Config = {
    account: {
        name: PluginConfigResponse['account']['name'];
        geolocation: PluginConfigResponse['account']['geolocation'];
        mapSettings: PluginConfigResponse['account']['mapSettings'];
        labelsWithUsage: PluginConfigResponse['account']['labelsWithUsage'];
    };
    extraData: ExtraSalestoolConfigResponse;
    businessContactInfo: PluginConfigResponse['businessContactInfo'];
    enableHeader?: PortfolioWidgetFeatureSettings['enableHeader'];
    enableFilters?: PortfolioWidgetFeatureSettings['enableFilters'];
    widgetHeight?: PortfolioWidgetFeatureSettings['widgetHeight'];
};

export type PluginConfigResponseWithExtra = PluginConfigResponse & {
    extraData: ExtraSalestoolConfigResponse;
};
